const initialState = {
  mekariLogoImg: 'https://cdn.mekari.design/logo/mekari/default.svg',
  logoImg: 'https://cdn.mekari.design/logo/talenta/default.svg',
  defaultBlankImg: '/assets/images/pages/No-data.svg', // old blank slate
  blankDocumentImg: '/assets/images/pages/blankslate-document.svg',
  blankFolderImg: 'https://cdn.mekari.design/illustration/blank-slate/NoData_PB_M_01.png',
  searchNotFoundImg: 'https://cdn.mekari.design/illustration/blank-slate/NotResultFound_PB_M_01.png',
  emptyGroupImg: 'https://cdn.mekari.design/illustration/blank-slate/EmptyRole_PB_M_01.png',

  restrictedImg: 'https://cdn.mekari.design/illustration/blank-slate/AccessRestricted_PB_M_01.png',
  invalidImg: 'https://cdn.mekari.design/illustration/blank-slate/Invalid_PB_M_01.png',
  processFailedImg: 'https://cdn.mekari.design/illustration/progress-feedback/ProcessFailed_PB_M_01.png',
  rejectedImg: 'https://cdn.mekari.design/illustration/progress-feedback/Rejected_PB_M_01.png',
  requestSentImg: 'https://cdn.mekari.design/illustration/progress-feedback/RequestSent_PB_M_01.png',

  reviewsOkImg: '/assets/images/pages/reviews/OK.svg',
  reviewsHeroImg: '/assets/images/pages/reviews/Hero.svg',

  goalsFirstrunDotImg: '/assets/images/pages/goals/journey_dot.svg',
  goalsFirstrun01Img: '/assets/images/pages/goals/browser_1.png',
  goalsFirstrun02Img: '/assets/images/pages/goals/browser_2.png',
  goalsFirstrun03Img: '/assets/images/pages/goals/browser_3.png',

  calibrationIntroImg: '/assets/images/pages/calibration/Discuss.png',
  calibrationIntro01Img: '/assets/images/pages/calibration/talenta-01.png',
  calibrationIntro02Img: '/assets/images/pages/calibration/talenta-02.png',
  calibrationIntro03Img: '/assets/images/pages/calibration/talenta-03.png',

  templatePresetImgsPath: '/assets/images/pages/template-presets/',

  blankAI: 'https://cdn.mekari.design/illustration/blank-slate/AiResources_PB_M_01.png',
};

export default {
  namespaced: true,
  state: () => ({ ...initialState }),
};
